import { lazy, Suspense, useEffect, useState } from "react";

const CookieConsent = lazy(() => import("@/components/CookieConsent"));

/** Баннер cookies — отложенная загрузка чанка после idle, не блокирует LCP. */
export function LazyCookieConsent() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (typeof window.requestIdleCallback === "function") {
      const id = window.requestIdleCallback(() => setReady(true), { timeout: 3000 });
      return () => window.cancelIdleCallback(id);
    }
    const timer = window.setTimeout(() => setReady(true), 1500);
    return () => window.clearTimeout(timer);
  }, []);

  if (!ready) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <CookieConsent />
    </Suspense>
  );
}
